module.exports = __webpack_public_path__ + "media/images/ui__themeToggleLight--dark-2f5f628e30148da6d51ada058ec872b4.png";